<template>
  <div v-if="userId" style="height: 608px; overflow-y: scroll">
    <div v-if="isLoading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else>
      <TreeTable v-model:selectionKeys="selectedKey" :value="data">
        <Column header="Объект" expander headerStyle="width: 25rem">
          <template #body="slotProps">
            <img :src="`images/24x24/${slotProps?.node?.data?.node_image_index}.png`" width="18" />
            {{ slotProps?.node?.data?.node_name }}
          </template>
        </Column>
        <Column header="Чт." bodyStyle="text-align: center;" headerStyle="text-align: center;">
          <template #body="slotProps">
            <Checkbox v-model="slotProps.node.data.node_reader" binary :disabled="!permissions.setting"
              @change="onChange(slotProps.node.data)" />
          </template>
        </Column>
        <Column header="Упр." bodyStyle="text-align: center;">
          <template #body="slotProps">
            <Checkbox v-model="slotProps.node.data.node_writer" binary :disabled="!permissions.setting"
              @change="onChange(slotProps.node.data)" />
          </template>
        </Column>
      </TreeTable>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';

const props = defineProps({
  userId: {
    type: Number,
    default: null,
  },
  permissions: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const toast = useToast();

const isLoading = ref(false);
const data = ref(null);
const selectedKey = ref([]);
const permissionService = ref(null);

const initService = () => {
  if (!permissionService.value) {
    permissionService.value = store.getters.nameToService(
      'BaseService',
      store.getters.info.login,
      store.getters.info.password,
      'user_permission',
      'data'
    );
  }
};

const buildData = (node_id, items) => {
  const result = [];
  for (const item of items) {
    if (item.node_parent_id === node_id) {
      const node = {
        data: item,
        key: item.node_id,
        children: [],
      };
      node.children = buildData(item.node_id, items);
      result.push(node);
    }
  }
  return result;
};

const loadPermissions = () => {
  if (!props.userId || props.userId < 0) {
    data.value = [];
    return;
  }
  isLoading.value = true;
  if (!permissionService.value) {
    initService();
  }
  permissionService.value
    .getData({ user_id: props.userId })
    .then((res) => {
      data.value = buildData(null, res);
    })
    .catch((er) =>
      store.commit('SET_ERROR', {
        er: er.response || er,
        source: ['PermissionData', 'userId', 'getData'],
      })
    )
    .finally(() => {
      isLoading.value = false;
    });
};

const onChange = (row) => {
  const payload = {
    user_id: row.user_id ?? props.userId,
    user_permission_id: row.user_permission_id,
    dept_id: row.dept_id,
    facility_type_id: row.facility_type_id,
    facility_id: row.facility_id,
    node_reader: row.node_reader,
    node_writer: row.node_writer,
  };
  if (!permissionService.value) {
    initService();
  }
  permissionService.value
    .putData(payload)
    .then(() => {
      toast.add({
        severity: 'success',
        summary: 'Права обновлены',
        detail: 'Разрешения на чтение/запись успешно применены',
        life: 1000,
      });
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['PermissionData', 'onChange', 'update'],
      });
    });
};

onMounted(() => {
  initService();
  if (props.userId) {
    loadPermissions();
  }
});

watch(
  () => props.userId,
  (newVal) => {
    if (newVal) {
      loadPermissions();
    } else {
      data.value = null;
    }
  }
);
</script>

<style lang="scss" scoped>
.image-text {
  vertical-align: middle;
}

.p-treetable .p-treetable-tbody>tr>td {
  padding: 0.2rem 0.2rem !important;
}
</style>